import { alpha } from '@mui/material';
const usePRadioStyles = () => {
    return {
        formControl: {
            width: '100%',
            border: (theme) => `1px solid ${alpha(theme.palette.grey[500], 0.24)}`,
            borderRadius: '14px',
            background: (theme) => theme.palette.common.grey8,
            minHeight: '53px'
        },
        formLabel: {
            fontSize: '14px',
            fontWeight: 500,
            color: 'text.primary',
            mb: 0.5
        },
        formControlLabel: {
            '& .MuiFormControlLabel-label.Mui-disabled': {
                fontSize: '14px',
                fontWeight: 400,
                color: (theme) => theme.palette.text.secondary
            }
        }
    };
};
export default usePRadioStyles;
